import { Reference } from "../../../state/AppState.ts";
import { HttpClient, Result } from "../../../../http/HttpClient.ts";

export class ReferenceApiService {
  constructor(private readonly httpClient: HttpClient) {}

  async getReferences(payload: {
    researchId: string;
  }): Result<{ references: Reference[] }> {
    const response = await this.httpClient.get<{
      references: {
        chunkInfo: {
          content: string;
          documentMetadata: {
            document: string;
            uri: string;
            title: string;
            pageIdentifier: string | null;
            structData?: {
              source_document_uri?: string;
              contextual_relevancy?: 0 | 1 | 2 | 3 | 4 | 5;
            };
          };
        };
      }[];
    }>(`/research/${payload.researchId}/references/`);
    return {
      success: response.success,
      data: response.data?.references && {
        references: response.data.references.map((reference) => ({
          id: reference.chunkInfo.documentMetadata.document,
          title: reference.chunkInfo.documentMetadata.title,
          page: reference.chunkInfo.documentMetadata.pageIdentifier || "",
          excerpt: reference.chunkInfo.content,
          // Try source_document_uri first, fall back to uri
          sourceUrl:
            reference.chunkInfo.documentMetadata.structData
              ?.source_document_uri || reference.chunkInfo.documentMetadata.uri,
          contextualRelevancy:
            reference.chunkInfo.documentMetadata.structData
              ?.contextual_relevancy,
        })),
      },
      httpStatus: response.httpStatus,
    };
  }

  async removeReferences(payload: {
    researchId: string;
    referenceIds: string[];
  }): Result {
    const response = await this.httpClient.patch(
      `/research/${payload.researchId}/references/file/`,
      {
        files: payload.referenceIds,
      },
    );
    return {
      success: response.success,
      httpStatus: response.httpStatus,
    };
  }
}
